<app-form-wrapper title="Send times">
  <div class="pv">
    @if (groups.length) {
      <!-- What the schedule adds up to -->
      <div class="pv__figure">
        <span class="pv__number">{{ formatCount(totalSends) }}</span>
        <span class="pv__caption">
          {{ totalSends === 1 ? "send" : "sends" }}
          @if (nextLabel) {
            · next <strong>{{ nextLabel }}</strong>
          }
        </span>
        @if (totalUnits !== null) {
          <span class="pv__caption">
            About <strong>{{ formatCount(totalUnits) }} SMS</strong> in all, at today’s audience
          </span>
        }
      </div>

      <hr class="pv__divider" />

      <ol class="pv__rows">
        @for (group of groups; track group.schedule.id) {
          <li class="pv__row">
            <div class="pv__row-main">
              <span class="pv__row-title">{{ group.subject }}</span>
              <ul class="pv__times">
                @for (time of group.times; track $index) {
                  <li>
                    <span>{{ time.label }}</span>
                    <span class="pv__countdown" [class.is-past]="time.past">
                      {{ time.past ? "already passed" : time.countdown }}
                    </span>
                  </li>
                }
              </ul>
            </div>
            <span class="pv__row-actions">
              <button
                type="button"
                class="bk-icon-btn"
                [attr.aria-label]="'Edit send times for ' + group.subject"
                matTooltip="Edit send times"
                (click)="openPopup(group.schedule)"
              >
                <span class="bk-sym" aria-hidden="true">edit</span>
              </button>
              <button
                type="button"
                class="bk-icon-btn is-danger"
                [attr.aria-label]="'Remove send times for ' + group.subject"
                matTooltip="Remove these send times"
                (click)="deleteSchedule(group.schedule.id)"
              >
                <span class="bk-sym" aria-hidden="true">delete</span>
              </button>
            </span>
          </li>
        }
      </ol>
    } @else {
      <p class="pv__empty">Send times you add appear here in order, with how long until each goes out.</p>
    }
  </div>
</app-form-wrapper>
